import { render, staticRenderFns } from "./s-info-plage-horaire.vue?vue&type=template&id=48727a76"
import script from "./s-info-plage-horaire.vue?vue&type=script&setup=true&lang=js"
export * from "./s-info-plage-horaire.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports